import React from "react"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

const SPECTRUM = [
  {
    name: "Preset Cloud",
    path: "/preset-cloud/",
    managed: "Preset manages everything",
    infra: "Preset's multi-tenant cloud",
    data: "Preset-hosted",
    compliance: "HIPAA, SOC 2 Type II",
    proprietary: true,
    airGap: false,
    highlight: false,
  },
  {
    name: "Managed Private Cloud",
    path: "/preset-managed-private-cloud/",
    managed: "Preset manages, your VPC",
    infra: "Your AWS / GCP / Azure",
    data: "Never leaves your VPC",
    compliance: "HIPAA, SOC 2, FedRAMP-ready",
    proprietary: true,
    airGap: false,
    highlight: false,
  },
  {
    name: "Preset On-Prem",
    path: "/preset-on-prem/",
    managed: "You operate",
    infra: "Any infra — cloud, hybrid, air-gapped",
    data: "Fully under your control",
    compliance: "Any regime, including air-gap",
    proprietary: true,
    airGap: true,
    highlight: true,
  },
  {
    name: "Preset Certified Superset",
    path: "/certified-superset/",
    managed: "You operate",
    infra: "Any infrastructure",
    data: "Fully under your control",
    compliance: "Any regime",
    proprietary: false,
    airGap: true,
    highlight: false,
  },
]

function CheckIcon({ filled }) {
  if (!filled) {
    return <span className="text-whisper-grey text-lg">—</span>
  }
  return (
    <svg
      className="h-5 w-5 text-lush mx-auto"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2.5}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  )
}

function DeploymentSpectrumSection() {
  return (
    <Container section className="py-16">
      <Heading
        level="h2"
        label="Compare"
        title="Find the right deployment model"
        subtitle="All models include Apache Superset at their core. The differences are in who manages the infrastructure, where your data lives, and which Preset capabilities are included."
        decoration="line"
      />

      <div className="mt-12 overflow-x-auto">
        <table className="w-full min-w-[640px] border-collapse text-sm">
          <thead>
            <tr>
              <th className="pb-4 text-left text-base font-bold text-dark-grey w-[28%]" />
              {SPECTRUM.map((model) => (
                <th
                  key={model.name}
                  className={`pb-4 px-3 text-center text-sm font-bold ${model.highlight ? "text-lush" : "text-cove"}`}
                >
                  <a
                    href={model.path}
                    className="hover:text-lush transition-colors"
                  >
                    {model.name}
                  </a>
                  {model.highlight && (
                    <span className="ml-1 text-xs text-lush">✦ New</span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-black-squeeze">
            {[
              {
                label: "Who manages infra",
                key: "managed",
                type: "text",
              },
              {
                label: "Runs on",
                key: "infra",
                type: "text",
              },
              {
                label: "Data residency",
                key: "data",
                type: "text",
              },
              {
                label: "Compliance",
                key: "compliance",
                type: "text",
              },
              {
                label: "Preset proprietary features",
                key: "proprietary",
                type: "check",
              },
              {
                label: "Air-gap compatible",
                key: "airGap",
                type: "check",
              },
            ].map((row) => (
              <tr key={row.label}>
                <td className="py-4 pr-4 text-left text-sm font-semibold text-dark-grey">
                  {row.label}
                </td>
                {SPECTRUM.map((model) => (
                  <td
                    key={model.name}
                    className={`py-4 px-3 text-center text-sm ${model.highlight ? "bg-catskill-white/50 rounded" : ""}`}
                  >
                    {row.type === "check" ? (
                      <CheckIcon filled={model[row.key]} />
                    ) : (
                      <span className="text-dark-grey">{model[row.key]}</span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Container>
  )
}

export default DeploymentSpectrumSection
